import useEffectOnMount from "../useEffectOnMount";
import scrollUp from "./scrollUp";

export default function useScrollUpOnMount({
  enabled = true
}: {
  enabled?: boolean;
} = {}) {
  useEffectOnMount(() => {
    if (enabled) scrollUp();
  });
}
